const StackColor = ({ name, desc, icon, altText }) => {
    const techStyles = {
        python: { bg: '#EAF9FC', border: '#E5E7EB'},
        csharp: { bg: '#EAF9FC', border: '#E5E7EB'},
        node: { bg: '#EAF9FC', border: '#E5E7EB'},
        java: { bg: '#EAF9FC', border: '#E5E7EB'},
        delphi: { bg: '#EAF9FC', border: '#E5E7EB'},

        react: { bg: '#EBF5EB', border: '#E5E7EB'},
        html: { bg: '#EBF5EB', border: '#E5E7EB'},
        css: { bg: '#EBF5EB', border: '#E5E7EB'},
        javascript: { bg: '#EBF5EB', border: '#E5E7EB'},
        typescript: { bg: '#EBF5EB', border: '#E5E7EB'},

        sqlserver: { bg: '#EAF9FC', border: '#E5E7EB'},
        mysql: { bg: '#EAF9FC', border: '#E5E7EB'},
        sqlite: { bg: '#EAF9FC', border: '#E5E7EB'},
        mongodb: { bg: '#EAF9FC', border: '#E5E7EB'},
        supabase: { bg: '#EAF9FC', border: '#E5E7EB'},

        github: { bg: '#EBF5EB', border: '#E5E7EB'},
        figma: { bg: '#EBF5EB', border: '#E5E7EB'},
        notion: { bg: '#EBF5EB',  border: '#E5E7EB'},
        vscode: { bg: '#EBF5EB', border: '#E5E7EB'},
        swagger: { bg: '#EBF5EB', border: '#E5E7EB'},

        tailwind: { bg: '#EAF9FC', border: '#E5E7EB'},
        springboot: { bg: '#EAF9FC', border: '#E5E7EB'},
        dotnet: { bg: '#EAF9FC', border: '#E5E7EB'},
        flask: { bg: '#EAF9FC', border: '#E5E7EB'},
        reactnative: { bg: '#EAF9FC', border: '#E5E7EB'},
        nextjs: { bg: '#EAF9FC', border: '#E5E7EB'},
        fastapi: { bg: '#EAF9FC', border: '#E5E7EB'},

        azure: { bg: '#EBF5EB', border: '#E5E7EB'},
        android: { bg: '#EBF5EB', border: '#E5E7EB'},
        linux: { bg: '#EBF5EB', border: '#E5E7EB'},
        windows: { bg: '#EBF5EB', border: '#E5E7EB'},
        git: { bg: '#EBF5EB', border: '#E5E7EB'},
        armbian: { bg: '#EBF5EB', border: '#E5E7EB'},
        vercel: { bg: '#EBF5EB', border: '#E5E7EB'},

        default: { bg: '#F0F0F0', border: '#E5E7EB'}
    };

    const currentStyle = techStyles[desc.toLowerCase()] || techStyles.default;

    return (
        <div style={{ 
            backgroundColor: currentStyle.bg,
            width: "min-content", 
            height: "40px", 
            padding: "10px 10px 10px 10px",
            display: "flex", 
            justifyContent: "center",
            justifyItems: "center",
            alignItems: "center",
            borderRadius: "10px",
            textAlign: "center",
            
            border: `1px solid ${currentStyle.border}`,
            boxShadow: `0 4px 10px ${currentStyle.border}30`
        }}>
            <img 
                src={icon} 
                alt={altText} 
                className="icon-stack" 
                style={{ objectFit: 'contain' }} 
            />
            <p className="item-tech">{altText}</p>
        </div>
    );
}

export default StackColor;